export class Registration {
    FirstName:string;
    MiddleName:string;
    LastName:string;
    LoginId:string;
    Password:string;
    RoleId:number;
    UserId:number;
    CompanyName:string;
    FormError:boolean;
    IsLoggedIn:boolean;
    CustomerId:number;
}